// extracted by mini-css-extract-plugin
module.exports = {"switch_tab_icon":"SwitchTabIcon_switch_tab_icon___6dyn"};